import type { UseSchemaBuilderConditionRowProps } from "./schema-builder-condition-row.type";
import type { SchemaOperator } from "@/entities/schema";

import { Form } from "antd";
import { useState } from "react";

import { isSchemaOperatorEmpty } from "@/entities/schema";

export const useSchemaBuilderConditionRow = ({
  fieldPath,
  initialValues,
}: UseSchemaBuilderConditionRowProps) => {
  const form = Form.useFormInstance();

  const isInitialEmpty = initialValues?.operator
    ? isSchemaOperatorEmpty(initialValues?.operator)
    : false;

  const [isEmptyOperator, setIsEmptyOperator] = useState(isInitialEmpty);

  const onOperatorChange = (operator: SchemaOperator) => {
    const isEmpty = isSchemaOperatorEmpty(operator);
    setIsEmptyOperator(isEmpty);
    if (isEmpty) resetValueField();
  };

  const resetValueField = () => {
    form.setFieldValue([...fieldPath, "value"], "");
  };

  return {
    isEmptyOperator,
    onOperatorChange,
  };
};
